import {
  Select
} from 'element-ui'

import { getValueByPath } from 'element-ui/src/utils/util';

import {
  isObject
} from "../../utils";

const option = {
  created () {
    if (this._events['before-input'] || this._events['beforeInput']) {
      const inputHandlers = this._events['input'] || []

      const proxyInputHandler = function (type, newVal) {
        const resolve = () => {
          inputHandlers.forEach(handler => handler(newVal))
        }

        this.$emit('before-input', resolve, newVal)
        this.$emit('beforeInput', resolve, newVal)
      }

      this._events['input'] = [proxyInputHandler.bind(this, 'input')]
    }

    this.getOption = (value) => {
      let option
      const isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]'
      const isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]'

      for (let i = this.cachedOptions.length - 1; i >= 0; i--) {
        const cachedOption = this.cachedOptions[i]
        const isEqual = isObject
          ? getValueByPath(cachedOption.value, this.valueKey) === getValueByPath(value, this.valueKey)
          : cachedOption.value === value
        if (isEqual) {
          option = cachedOption
          break
        }
      }

      if (option) return option
      let label

      if (!isObject && !isNull) {
        label = value
      } else if(isNull) {
        label = ''
      } else {
        label = value[this.$attrs.labelKey || this.$attrs['label-key']]
      }

      let newOption = {
        value: value,
        currentLabel: label
      }

      if (this.multiple) {
        newOption.hitState = false
      }

      return newOption
    }
  }
}

if (!Select.mixins) Select.mixins = []

Select.mixins.push(option)
